<script lang="ts">
    import cn from 'classnames';

    import { isUpdateTaxAlertNeeded } from '@components/profile/forms/payment-details/functions';
    import { dialogStore } from '@components/ui/dialog';
    // eslint-disable-next-line no-restricted-imports
    import { userStore } from '@components/user/store';
    import { PayoutDetailsStatus } from '@shared/types';
    import { getFormattedBalance } from '@shared/utils/getFormattedBalance';
    import { Button, ButtonTypes } from '@uikit/button';
    import { Font, FontTypes } from '@uikit/font';
    import { Size } from '@uikit/types';

    import s from './balance.module.css';

    export let isDesktop: boolean;

    function showIncomeDialog() {
        dialogStore.showIncome({
            balance: $userStore.user?.operator?.balance ?? 0,
            bonusBalance: $userStore.user?.operator?.bonusBalance ?? 0,
        });
    }

    $: operatorBalance = getFormattedBalance($userStore.user?.operator?.balance);
    $: hasPayoutData = Boolean($userStore?.user?.operator?.payoutMethod);
    $: alertIndicator = $userStore.user?.operator?.payoutDetailsStatus === PayoutDetailsStatus.Invalid
        || isUpdateTaxAlertNeeded($userStore?.user);
</script>

<div class={s.container}>
    <Button
        attrs={{ 'data-testid': 'operatorBalanceButton' }}
        classes={cn(s.balance, { [s.desktop]: isDesktop, [s.alertIndicator]: alertIndicator })}
        color={ButtonTypes.Color.Secondary}
        size={Size.Small}
        on:click={showIncomeDialog}
    >
        <Font
            type={isDesktop ? FontTypes.Type.body : FontTypes.Type.caption}
            color={FontTypes.Color.Invert}
            tagName={FontTypes.TagName.span}
            isBold
        >
            {operatorBalance}
        </Font>
    </Button>

    {#if !hasPayoutData}
        <div class={s.round}></div>
    {/if}
</div>
